import { get } from "@ember/object"
import type { Card, CardStack } from "@shared/models/card-stack"
import { format, parseISO } from "date-fns"
import type { DefaultLessonModels } from "./default-lesson-models"

export interface LessonContext {
  cardTitle?: string | null | undefined
  cardStackId: string | null
  cardStackTitle: string | null | undefined
  cardStackType: CardStack["attributes"]["usedAs"] | undefined
  cardStackVersionBeingEdited: number
  courseId: string | null | undefined
  courseTitle: string | null | undefined
  date: string
  planbookId: string | undefined
  planbookTitle: string | undefined
  userOwnsPlanbook: boolean
  userId: string | undefined
  /**  In the backend, we assume it's manual if it's undefined or null */
  editType?: undefined | "template" | "paste" | "manual" | "ai" | null
  cardType?: Card["type"]
  donorCardStackTitle?: string | null
  donorCardStackId?: string | null
  cardToPasteTitle?: string
  cardToPasteId?: string
  cardToReplaceTitle?: string
  cardToReplaceId?: string
  standards?: Array<string>
  standardSets?: Array<string>
}

export default function (_payload, models: DefaultLessonModels): LessonContext {
  let cardStackType = get(models, "cardStackType")
  let unit = get(models, "unit")
  let courseDate = get(models, "courseDate")

  let formattedDateString = (function (cardStackType) {
    switch (cardStackType) {
      case "lesson":
        return courseDate
          ? // @ts-ignore This is actually a course-date-custom but we didn't do the right type checking.
            format(parseISO(courseDate.attributes.dateString), "EEE, LLL. d, yyyy")
          : ""
      case "unit":
        return unit
          ? format(parseISO(unit.startDate), "EEE, LLL. d, yyyy") +
              " to " +
              format(parseISO(unit.endDate), "EEE, LLL. d, yyyy")
          : ""
      case "lesson-template":
        return "Template"
      default:
        return "Unknown"
    }
  })(cardStackType)

  return {
    cardStackId: models.cardStack.id,
    cardStackTitle: models.cardStack.attributes?.title,
    cardStackType: cardStackType,
    cardStackVersionBeingEdited: models.cardStack.attributes?.version,
    courseId: models.courseId ?? undefined,
    courseTitle: models.course?.attributes?.title,
    date: formattedDateString,
    planbookId: models.planbookId,
    planbookTitle: models.planbook?.attributes?.title,
    userOwnsPlanbook: models.planbook?.relationships?.owner?.data?.id === models.user?.id,
    userId: models.user?.id,
  }
}
